import { Scope } from '../../../../environments/environment.interfaces';

export const BASKET_SCOPE_PROD: Scope = {
    api: 'BASKET',
    scopes: [
        'openid',
        'https://login.sew-eurodrive.com/75305880-5b75-4490-b918-aebae12328c4/Basket.Read',
        'offline_access',
    ],
};

export const WISHLIST_SCOPE_PROD: Scope = {
    api: 'WISHLIST',
    scopes: [
        'openid',
        'https://login.sew-eurodrive.com/c2b60b56-f786-4a24-a840-353e659e74a8/WishList.Read',
        'offline_access',
    ],
};

export const WZ_SCOPE_PROD: Scope = {
    api: 'WZ',
    scopes: [
        'openid',
        'https://login.sew-eurodrive.com/057d8fbd-e788-4813-b701-a793281a46ff/FullAccess',
        'offline_access',
    ],
};
